import clsx from "classnames";
import classes from "./styles.module.scss";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import HeaderTitle from "@/components/HeaderTitle";
import ContactButton from "@/components/ContactButton";
import { useRouter } from 'next/router';
import { getGlobal } from "@/functions/getGlobal";

export default function Office({ office={}, className }) {
  const global = getGlobal();
  
  // const facebook = global["_theme.social.facebook"];
  // const twitter = global["_theme.social.twitter"];
  // const linkedin = global["_theme.social.linkedin"];
  // const instagram = global["_theme.social.instagram"];

  const router = useRouter();
  const pathName = 'https://earthstreamglobal.com' + router.asPath;

  return (
    <div className={clsx(className, classes.office)}>
      <div className={classes.left_section}>
        <div className={classes.title}>
          <HeaderTitle title={office.location}/>
        </div>
        <div className={classes.office_detail}>
          <img className={classes.location_image} src={office.image} alt={office.title}></img>
          <div className={classes.contact_detail}>
            <h6 className={classes.label}>get in touch</h6>
            <div className={classes.contacts}>
              
              <div className={classes.icon}>
                <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={office.google_map_link} icon={"/icons/location.png"} alt="location"></ContactButton>
                <a className={classes.address} href={office.google_map_link}>{office.address}</a>
              </div>
              <div className={classes.icon}>
                <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={`mailto:${office.email.trim()}`} icon={"/icons/envelope.png"} alt="email"></ContactButton>
                <a className={classes.address} href={`mailto:${office.email.trim()}`}>{office.email}</a>
              </div>
              <div className={classes.icon}>
                {office?.url_slug === 'cape-town' ? "" : <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={`tel:${office.phone}`} icon={"/icons/call.png"} alt="phone"></ContactButton>}
                
                <a className={classes.address} href={`tel:${office.phone}`}>{office.phone}</a>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.socials}>
          <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={office.linkedin} icon={"/icons/linkedin.png"} alt="linkedin"></ContactButton>
          <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={office.twitter} icon={"/icons/twitter.png"} alt="twitter"></ContactButton>
          <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={office.facebook} icon={"/icons/facebook.png"} alt="facebook"></ContactButton>
          <ContactButton hoverType="dark" buttonSize="48px" iconSize="20px" href={office.instagram} icon={"/icons/instagram.png"} alt="instagram"></ContactButton>
        </div>
      </div>

      <div className={classes.right_section}>
        <h2 className={classes.enquiry_title}>submit an enquiry</h2>
        <div className={classes.enquiry_subtitle}>For your general enquiries, please fill the form below</div>
        <SourceFlowForm
          onSubmitDone={() => (window.location.href = '/office-thank-you')}
          formId={'dbf63463-a0eb-453d-9f7a-03753d2b42c2'}
        />
      </div>
    </div>
  );
}

Office.defaultProps = {
  className: "",
};
